import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiFilterOption } from './ui-filter-bar.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-filter-bar',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-filter-bar.component.html',
  styleUrl: './ui-filter-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFilterBarComponent {
  readonly filters = input<UiFilterOption[]>([]);
  readonly selected = input('');
  readonly changed = output<string>();

  select(value: string, disabled?: boolean): void {
    if (disabled) {
      return;
    }

    this.changed.emit(value);
  }
}
